import { useQuery } from '@apollo/client';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CycleVisitContainer, CycleVisitTextContainer } from './CycleVisit.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { themes, utils } from 'kb-shared';
import { BugTracker } from 'kb-shared/utilities/bugTracker';
import { momentFormatted } from 'kb-shared/utilities/momentHelpers';

import { CYCLE_VISIT_DAYS } from '../Dashboard.graphql';
import { CycleVisitDaysResponse } from '../Dashboard.types';
import { calculateNextCycleVisitDate } from './CycleVisit.mapper';

export const CycleVisit = (): JSX.Element | null => {
  const { cycleVisitId } = utils;
  const navigate = useNavigate();
  const { data, loading } = useQuery<CycleVisitDaysResponse>(CYCLE_VISIT_DAYS, {
    onError: error => BugTracker.notify(error, 'Cycle Visit Days Fetch')
  });

  if (loading) return null;

  const nextCycleVisit = calculateNextCycleVisitDate(data?.cycleVisitDays, data?.cycleVisits);

  if (!nextCycleVisit) return null;

  const dateFormatted = momentFormatted(nextCycleVisit, 'M/D');

  const navigateToBookingQuiz = () =>
    navigate(`/booking/book?step=location&appointment_id=${cycleVisitId()}&date=${nextCycleVisit}`);

  return (
    <CycleVisitContainer>
      <CycleVisitTextContainer>
        <Heading styledAs="h2" color={themes.colors.semantic.pink} noMargin>
          Schedule Your Next Cycle Visit!
        </Heading>
        <Text size="lg" color={themes.colors.semantic.pink}>
          Please schedule your next cycle visit for{' '}
          <Text color={themes.colors.white}>{dateFormatted}</Text>
        </Text>
      </CycleVisitTextContainer>
      <Button
        label={`Schedule Visit for ${dateFormatted}`}
        onClick={navigateToBookingQuiz}
        category="primary"
      />
    </CycleVisitContainer>
  );
};
